import CommonFooter from '../components/common/CommonFooter';
import SearchBox from '../components/common/SearchBox';
import PostCardList from '../components/post-card/PostCardList';
import Meta from '../components/common/Meta';
import PageHero from '../components/common/PageHero';
import RedesignPageLayout from '../components/common/RedesignPageLayout';
import { useSearchParams } from 'react-router-dom';
import HomePopularBlogsHeader from '../components/home/HomePopularBlogsHeader';

export default function HomePage() {
    const [searchParams] = useSearchParams();
    const keyword = searchParams.get('keyword') || '';
    const sort = 'latest';
    const showPinned = false;

    return (
        <>
            <Meta />
            <RedesignPageLayout
                isHome="true"
                hero={
                    <PageHero
                        image="/assets/images/sites/redesign/home-hero.png"
                        variant="home"
                        imagePosition="72% center"
                        title={<>发现独立思想，<br />记录真实世界。</>}
                        subtitle="博客中心收录中文独立博客，聚合 RSS 最新文章。在这里发现有趣的博主，阅读原创优质内容。"
                    >
                        <div className="redesign-search">
                            <SearchBox placeholder="搜索博客 / 文章…" gotoPage="/home" sortType="latest" />
                        </div>
                    </PageHero>
                }
            >
                <section className="redesign-section">
                    <h2 className="redesign-section-title">最近收录博客</h2>
                    <HomePopularBlogsHeader />
                </section>

                <section className="redesign-section">
                    <h2 className="redesign-section-title">最新文章</h2>
                    <PostCardList sort={sort} keyword={keyword} showPinned={showPinned} />
                </section>
            </RedesignPageLayout>
        </>
    );
}
